import { state } from '@/store/contact/state';
import { actions } from '@/store/contact/actions';
import { mutations } from '@/store/contact/mutations';
import { getters } from '@/store/contact/getters';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export { state, mutations, actions, getters };
